import Event from './Event';

export default function Column({
  dayName,
  dayIndex,
  events,
  trads,
  lang,
  demoMode,
  onEventClick,
  onAddEvent,
}) {
  const sortedEvents = [...events].sort(
    (a, b) => (a.times?.[0] ?? 0) - (b.times?.[0] ?? 0)
  );

  const handleAddClick = () => {
    onAddEvent?.(dayIndex);
  };

  return (
    <div className="flex flex-col min-h-[400px]">
      <div
        className="font-bold text-gray-800 text-center py-2 rounded-t-lg border-b border-gray-200"
        data-umami-event="click day"
      >
        {dayName}
      </div>
      <div className="flex-1 bg-gray-50 p-1 space-y-2 rounded-b-lg overflow-y-auto">
        {sortedEvents.length === 0 ? (
          <></>
        ) : (
          sortedEvents.map((event) => (
            <Event
              key={event.id}
              event={event}
              trads={trads}
              lang={lang}
              demoMode={demoMode}
              onClick={onEventClick}
            />
          ))
        )}
        <button
          type="button"
          onClick={handleAddClick}
          data-testid="add-sms-event"
          data-umami-event={demoMode ? 'click demo add sms' : undefined}
          className="w-full text-center py-2 text-sm font-medium text-gray-900 underline hover:text-gray-700 cursor-pointer"
        >
          {trads?.index?.addSmsEvent || 'Add SMS event'}
        </button>
      </div>
    </div>
  );
}
